import { PropsWithChildren } from 'react'

export default function DropdownItem({ children }: PropsWithChildren) {
    return <li className="dd-item">{typeof children === 'string' ? <span>{children}</span> : children}</li>
}
